import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { PermissionService } from '@dal/core';

@Component({
  selector: 'dal-shared-ui-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss',
})
export class SidenavComponent implements OnChanges {
  @Input() elements: {
    name: string;
    link: string;
    permissions?: string[];
  }[] = [];
  @Input() showSideNav = false;
  @ViewChild('sidenav') sidenav: MatSidenav;

  constructor(private route: Router, private permissionService: PermissionService) {}
  ngOnChanges(): void {
    if (this.sidenav !== undefined) {
      this.sidenav?.toggle();
    }
  }

  goto(link: string): void {
    this.route.navigateByUrl(link);
    this.sidenav.close();
  }

  /**
   * Check if a menu item should be visible based on user permissions
   * If no permissions are specified, the item is always visible
   */
  canShowMenuItem(permissions?: string[]): boolean {
    if (!permissions || permissions.length === 0) {
      return true;
    }
    return this.permissionService.hasAnyPermission(permissions);
  }

  logout(): void {
    // this.oktaAuthService.logout();
  }
}
